import React, { useMemo } from "react"
import {
  CurrentEventsList,
  UpcomingEventsSlide,
} from "components/domains/events"
import { Carousel, CarouselItem } from "components/Carousel"
import { useTranslation } from "providers/i18n"
import { Head } from "../../components/Head"
import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material"
import { Link } from "react-router-dom"
import { EmptyData } from "components/EmptyData"
import { CalendarStarIcon } from "../../components/icons"
import { VerticalEventCard } from "../../components/domains/events"
import { useEvent } from "hooks/event/useEvent"
import { getIcon } from "utils/icon"

export const Events = () => {
  const { t } = useTranslation()
  const { groupEvents, activeGroupEvent, handleChange } = useEvent()

  const theme = useTheme()
  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.events) || <CalendarStarIcon />,
    [theme]
  )
  const { styleOverrides } = theme.components?.[`EventPage`] || {}
  const {
    root,
    carouselContainer,
    carousel,
    eventGroupSelectorButton,
    cardListContainer,
    emptyDataWrapper,
  } = styleOverrides

  return (
    <>
      <Head title={t("Events & Activities")} />
      <Box sx={root}>
        <Box sx={cardListContainer}>
          <CurrentEventsList events={groupEvents["current"]} />
          <UpcomingEventsSlide events={groupEvents["upcoming"]} />
        </Box>
        <Box sx={carouselContainer}>
          {groupEvents[activeGroupEvent] &&
          groupEvents[activeGroupEvent].length > 0 ? (
            <Carousel
              options={{
                type: "loop",
                padding: "25%",
                pagination: true,
                autoplay: true,
                interval: 10000,
              }}
              sx={carousel}
            >
              {groupEvents[activeGroupEvent].map((event) => (
                <CarouselItem key={event.id}>
                  <Link to={`/events/${event.id}`}>
                    <VerticalEventCard event={event} />
                  </Link>
                </CarouselItem>
              ))}
            </Carousel>
          ) : (
            <Box sx={emptyDataWrapper}>
              <EmptyData
                icon={emptyIcon}
                primary={
                  activeGroupEvent === "current"
                    ? t(`No Current Events`)
                    : t(`No Upcoming Events`)
                }
                secondary={t("Check Back Soon")}
              />
            </Box>
          )}
          <Box sx={eventGroupSelectorButton}>
            <ToggleButtonGroup
              value={activeGroupEvent}
              onChange={handleChange}
              exclusive
            >
              <ToggleButton value="current">{t("Current Events")}</ToggleButton>
              <ToggleButton value="upcoming">
                {t("Upcoming Events")}
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Box>
      </Box>
    </>
  )
}
